import cn from 'classnames';

const KlaviyoComponent = ({ newsletter, className }) => {
  if (!newsletter?.formId) {
    return null;
  }
  return <div className={cn(`klaviyo-form-${newsletter.formId}`, className)} />;
};

export default KlaviyoComponent;
